<template>
  <client-only>
    <div>
      <!-- Empty route page for /cc  -->
    </div>
  </client-only>
</template>

<script>
export default {
  created() {
    this.$router.push('/')
  }
}
</script>
